<script lang="ts">
  import { getFromObject } from '$shared/helpers/utils';

  interface Props {
    row: ObjectType<any>;
    col: ColumnType;
  }

  let { row, col }: Props = $props();
  let value = $derived(getFromObject(col.id, row) || '');
  let isActive = $derived(getFromObject('isActive', row) || '');
</script>

<div class="comp-status-cell" class:active={isActive}>{value}</div>

<style>
  .comp-status-cell {
    display: flex;
    align-items: center;
  }
  .comp-status-cell::before {
    content: '';
    width: 14px;
    height: 14px;
    display: block;
    background-color: var(--grey-xlight);
    border-radius: 50%;
    margin-right: 8px;
  }
  .comp-status-cell.active::before {
    background-color: var(--green);
  }
</style>
